import { PRODUCT_ID } from '../constants/productId';
import { CryoType } from '../types';

export const getCryoType = (
  productId: number | undefined | null
): CryoType | null => {
  if (!productId) {
    return null;
  }

  if (productId === PRODUCT_ID.FFP_CRYOPRECIPITATE_CRYO_RICH) {
    return 'Cryo-rich';
  }

  if (productId === PRODUCT_ID.FFP_CRYOPRECIPITATE_CRYO_POOR) {
    return 'Cryo-poor';
  }

  return null;
};
